<template>
  <div class="SearchMain">
    <div class="search">
      <div class="search1">
        <div class="left">
          <el-input @keyup.enter.native="search" clearable placeholder="如：Java SpringCloud" v-model="params.keyword"
            size="small" class="input-with-select">
            <el-select v-model="params.searchType" slot="prepend" placeholder="任意词">
              <el-option label="任意词" value="0"></el-option>
              <el-option label="精准词" value="1"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" @click="search()">搜索</el-button>
          </el-input>
        </div>
        <div class="right">
          <div class="text">精准查找：</div>
          <el-input placeholder="手机号/邮箱/姓名" v-model="params.jzKeyword" clearable @keyup.enter.native="search()"
            size="small">
          </el-input>
        </div>
      </div>
      <div class="search2">
        <div class="left">
          <div class="container">
            <div class="text">职位名称：</div>
            <el-input placeholder="职位名称" v-model="params.jobName" clearable @keyup.enter.native="search()" size="small">
            </el-input>
          </div>
        </div>
        <div class="between">
          <div class="container">
            <div class="text">公司名称：</div>
            <el-input placeholder="公司名称" v-model="params.compName" clearable @keyup.enter.native="search()"
              size="small">
            </el-input>
          </div>
        </div>
        <div class="right">
          <div class="container">
            <div class="text">毕业院校：</div>
            <el-input placeholder="学校名称" v-model="params.school" clearable @keyup.enter.native="search()" size="small">
            </el-input>
          </div>
        </div>
      </div>
      <div class="search2">
        <div class="left">
          <div class="container">
            <div class="text">学  历：</div>
            <el-select v-model="params.eduLevel" placeholder="教育经历（不限）" size="small">
              <el-option v-for="item in edus" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="between">
          <div class="container">
            <div class="text">性  别：</div>
            <el-select v-model="params.gender" placeholder="不限" size="small">
              <el-option v-for="item in genders" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="right">
          <div class="container">
            <div class="text">其  他：</div>
            <el-select v-model="params.jobStatu" placeholder="求职状态（不限）" size="small">
              <el-option v-for="item in jobStatus" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="search2">
        <div class="left">
          <div class="container">
            <div class="text">年  龄：</div>
            <div class="work">
              <el-input v-model="params.ageLow" maxlength="2" placeholder="岁" size="small"></el-input>
              <div class="workText">至</div>
              <el-input v-model="params.ageHigh" placeholder="不限" size="small"></el-input>
            </div>
          </div>
        </div>
        <div class="between">
          <div class="container">
            <div class="text">工作年限：</div>
            <div class="work">
              <el-input v-model="params.workYearsLow" maxlength="2" placeholder="年" size="small"></el-input>
              <div class="workText">至</div>
              <el-input v-model="params.workYearsHigh" placeholder="不限" size="small"></el-input>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="container">
            <div class="text">专  业：</div>
            <el-input placeholder="专业名称" v-model="params.major" clearable size="small">
            </el-input>
          </div>
        </div>
      </div>
      <div class="search2">
        <div class="left">
          <div class="school">
            <div class="text">院校要求：</div>
            <div class="schoolBox">
              <div v-for="(item, i) in waitSelects" :key="i"
                :class="productNoSelects.some(select => select.value === item.value) ? 'select_product_no_button' : 'product_no_button'"
                @click="productNoSelect(item)">
                <span>{{ item.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="search2">
        <div class="left">
          <div class="sfilter-city">
            <div class="text">期望城市：</div>
            <selectArea :name="'wantDqs'" @changeWantDqs="wantDqsData"></selectArea>
          </div>
        </div>
      </div>
    </div>
    <div class="resume-box" v-loading="loading" element-loading-text="拼命加载中">
      <div class="resume-box-sort">
        <div class="sort-left">
          <el-checkbox v-model="params.isShowYd" @change="search()">隐藏已读</el-checkbox>
        </div>
        <div class="sort-right">
          <span class="resume-num" style="margin-right: 24px; user-select: none;" v-if="total !== 0">
            共
            <i style="color: #409EFF;">{{ total }}</i>
            位人选
          </span>
          <div class="paixu">
            <el-select v-model="params.label" placeholder="请选择标签" size="small">
              <el-option v-for="item in labels" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="params.sort" placeholder="请选择排序" size="small">
              <el-option v-for="item in sorts" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="resume-card-wrap" v-if="showData">
        <div :class="['new-card-search', { read: item.isRead === 1 }, { share: item.isShare === 1 }]"
          v-for="(item, i) in resumeList" :key="i" @click="readResume(item.id, i, item.isShare)">
          <div class="new-card-right">
            <div class="card-right-top">
              <div class="card-right-top-left"><span style="font-size: 16px; font-weight: bold;margin-right: 8px;">{{
                item.name }}</span> {{ item.gender == '1' ? '男' : '女' }} | {{ item.birthDate | toAge
                  }}
                |
                {{ item.workYear | toworkYear }} | 期望 {{ item.expectCity | toArea }} | {{ item.jobStatus |
                  tojobStatus }} | {{ item.label | toLabel }}
              </div>
              <div class="card-right-top-right">{{ item.update_time }}更新于<span>{{
                item.channel | toChannel
              }}</span>
              </div>
            </div>
            <div class="card-right-bottom">
              <div class="card-right-bottom-edu">
                <div class="edu-text" v-for="(item2, i2) in item.edu" :key="i2">{{
                  item2.eduName }}-{{ item2.professional }}-{{ item2.degree | toDegree }} {{
                    item2.startTime }}-{{ item2.endTime | toEndTime(item2.startTime) }}
                </div>
              </div>
              <div class="card-right-bottom-work">
                <div class="work-text" v-for="(item3, i3) in item.works" :key="i3">
                  <div v-html="workExp(item3.startTime, item3.endTime, item3.companyName, item3.jobName)"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="isRead" v-if="item.isRead === 1">
            <div>阅</div>
          </div>
          <div class="isShare" v-if="item.isShare === 1">
            <div>共享</div>
          </div>
        </div>
      </div>
      <div class="waitShow" v-else>
        <div class="desc">暂无数据</div>
      </div>
    </div>
    <div class="pag">
      <el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="20"
        layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetResumeList, readCache } from '@/request/api'
import selectArea from '@/components/selectArea.vue'

export default {
  components: { selectArea },
  beforeDestroy() {
    localStorage.removeItem('searchKey');
  },

  created() {
    localStorage.removeItem('searchKey');
  },
  data() {
    return {
      searchKey: [],
      loading: false,
      showData: false,
      params: {
        searchType: '1',
        keyword: '',
        jzKeyword: '',
        jobName: '',
        compName: '',
        school: '',
        eduLevel: '',
        gender: '',
        jobStatu: '',
        ageLow: '',
        ageHigh: '',
        workYearsLow: '',
        workYearsHigh: '',
        major: '',
        wantDqs: '',
        isShowYd: false,
        sort: '1',
        label: '',
        academy: '',
        pageNum: 1,
        username: ''
      },

      edus: [
        {
          value: '',
          label: '不限'
        },
        {
          value: '1',
          label: '大专以下'
        },
        {
          value: '2',
          label: '大专'
        },
        {
          value: '3',
          label: '本科'
        },
        {
          value: '4',
          label: '硕士'
        },
        {
          value: '5',
          label: '博士'
        },
        {
          value: '6',
          label: 'MBA/EMBA'
        }
      ],
      genders: [
        {
          value: '',
          label: '不限'
        },
        {
          value: 1,
          label: '男'
        },
        {
          value: 0,
          label: '女'
        }
      ],
      jobStatus: [
        {
          value: '',
          label: '不限'
        },
        {
          value: 1,
          label: '离职-随时到岗'
        },
        {
          value: 2,
          label: '在职-暂不考虑'
        },
        {
          value: 3,
          label: '在职-考虑机会'
        },
        {
          value: 4,
          label: '在职-月内到岗'
        }
      ],
      resumeList: [],
      total: 0, // 简历数
      currentPage: 1,
      labels: [{
        value: 1,
        label: '战略匹配型(超出预期)'
      }, {
        value: 2,
        label: '胜任匹配型(符合要求)'
      }, {
        value: 3,
        label: '发展适配型(具备潜力)'
      }, {
        value: 4,
        label: '暂不匹配型(不太符合)'
      }],
      sorts: [{
        value: '1',
        label: '智能排序'
      }, {
        value: '2',
        label: '更新时间'
      }],
      waitSelects: [{ value: '9999', label: '不限' }, { value: '211', label: '211' }, { value: '985', label: '985' }, { value: '666', label: '一本' }, { value: '888', label: '统招本科' }],
      productNoSelects: [{ value: '9999', label: '不限' }],
      schoolLength: 0,
    }
  },
  methods: {
    workExp(val1, val2, val3, val4) {
      return val1 + '-' + this.$options.filters.toEndTime(val2, val1) + ' ' + val3 + ' - ' + val4
    },
    productNoSelect(val) {
      if (val.label === '不限') {
        this.productNoSelects = [{ value: '9999', label: '不限' }];
        this.schoolLength = 0;
        return;
      }
      if (this.productNoSelects.length > 0) {
        if (this.productNoSelects.length === 1 && this.productNoSelects[0].label === '不限') {
          this.productNoSelects = [];
        }
      }
      // 判断当前选项是否已被选中
      const index = this.productNoSelects.findIndex(item => item.value === val.value);

      if (index !== -1) {
        this.productNoSelects.splice(index, 1);
        this.schoolLength -= 1;
      } else if (this.schoolLength < 3) {
        this.productNoSelects.push(val);
        this.schoolLength += 1;
      }
    },
    async handleCurrentChange(value) {
      this.params.pageNum = value
      const { data: res } = await GetResumeList(this.params)
      this.resumeList = []
      this.resumeList = res.data
      this.total = res.total
    },
    async search() {
      this.searchKey = [];
      localStorage.removeItem('searchKey');
      if (this.params.jobName !== '') {
        this.searchKey.push(this.params.jobName)
      }
      if (this.params.compName !== '') {
        this.searchKey.push(this.params.compName)
      }
      this.params.academy = this.productNoSelects.map(item => item.value).join("，")
      this.params.username = JSON.parse(sessionStorage.getItem('LoginInfo')).username;
      this.loading = true
      this.currentPage = 1
      this.params.pageNum = 1
      const { data: res } = await GetResumeList(this.params)
      this.resumeList = []
      this.total = res.total
      if (res.code == 200) {
        this.loading = false
        this.resumeList = res.data.map(item => {
          let newItem = JSON.stringify(item)
          this.searchKey.map(key => {
            let pattern = new RegExp(key, 'gi')
            newItem = newItem.replace(pattern, "<span class='HPRK'>" + key.toUpperCase() + '</span>')
          })
          return JSON.parse(newItem)
        })
        console.log(this.resumeList);

        if (this.resumeList.length > 0) {
          this.showData = true;
        } else {
          this.showData = false;
        }
      }
    },
    wantDqsData(data) {
      this.params.wantDqs = data
    },
    async readResume(resumeID, i, isShare) {
      if (this.params.keyword !== '' && this.params.keyword.indexOf(' ') != -1) {
        this.searchKey.push(this.params.keyword.split(' '))
      } else if (this.params.keyword !== '' && this.params.keyword.indexOf(' ') == -1) {
        this.searchKey.push(this.params.keyword)
      }

      if (this.searchKey != '' && this.searchKey !== null && this.searchKey !== 'underfined') {
        localStorage.setItem('searchKey', JSON.stringify(this.searchKey))
      }
      var { data: res } = await readCache({ username: JSON.parse(sessionStorage.getItem('LoginInfo')).username, resumeID: resumeID });
      this.resumeList[i].isRead = 1;
      window.open('#/resume?resumeID=CA' + (resumeID + 100000000) + '&isShare=' + isShare + '&timestamp=' + Date.now())
    },
    Textleft(text, key) {
      var index = text.indexOf(key)
      text = text.substring(0, index)
      return text
    },
    Textright(text, key) {
      var index = text.indexOf(key)
      text = text.substr(index + 1)
      return text
    },
    Textbetween(str, left_key, right_key) {
      var g_left = str.indexOf(left_key)
      if (g_left != -1) {
        g_left = g_left + left_key.length
        var g_right = str.indexOf(right_key, g_left)
      }
      if (g_right != -1) {
        return str.substr(g_left, g_right - g_left)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

::v-deep .HPRK {
  color: #409eff;
}

input::-webkit-input-placeholder {
  color: #bcbfc1;
}

input:hover {
  border: 1px solid #dadbdd;
}

input:focus {
  border: 1px solid #409eff;
}


.SearchMain {
  background: rgb(239, 242, 251);
  padding: 30px 266px 0 266px;
  min-height: 100%;

  .search {
    background: #fff;
    padding: 20px;
    border-radius: 4px;
    width: 1000px;

    .search1 {
      display: flex;
      justify-content: space-between;
      justify-items: center;
      align-items: center;

      .left {
        .el-input {
          width: 588px;

          .el-select {
            width: 90px;
          }
        }
      }

      .right {
        display: flex;
        justify-items: center;
        align-items: center;

        .text {
          font-size: 14px;
          width: 100px;
        }
      }
    }

    .search2 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;

      .left {
        .school {
          display: flex;
          align-items: center;

          .text {
            font-size: 14px;
            width: 70px;
            white-space: nowrap;
          }

          .schoolBox {
            display: flex;
            justify-items: center;
            align-items: center;
            width: 100%;
            cursor: pointer;
            font-size: 14px;
            height: 20px;
            line-height: 20px;
            white-space: nowrap;

            .product_no_button {
              padding: 0 10px;
              color: #333;
            }

            .select_product_no_button {
              display: inline-block;
              padding: 0 10px;
              color: #3d9ccc;
              font-weight: 600;
            }
          }
        }

        .sfilter-city {
          display: flex;
          justify-items: center;
          align-items: center;
          width: 950px;
          height: 24px;
          line-height: 24px;

          .text {
            font-size: 14px;
            width: 70px;
            white-space: nowrap;
          }
        }
      }

      .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 300px;

        .text {
          font-size: 14px;
          white-space: nowrap;
        }

        .el-select {
          width: 100%;
        }

        .el-slider {
          width: 100%;
        }

        .work {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;

          .el-input {
            width: 100%;
          }

          .workText {
            padding: 10px;
          }
        }
      }
    }
  }

  .resume-box {
    margin-top: 10px;
    width: 1000px;

    .resume-box-sort {
      height: 50px;
      line-height: 70px;
      background-color: #e9ecf1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;

      .sort-left {
        display: flex;
        align-items: center;

      }

      .sort-right {
        display: flex;
        align-items: center;

        .paixu {
          display: flex;

          .el-select {
            width: 110px;
            margin-right: 10px;
          }
        }
      }
    }

    .waitShow {
      height: 188px;
      position: relative;
      user-select: none;
      font-size: 16px;
    }

    .desc {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #909399;
    }

    .resume-card-wrap {
      cursor: pointer;
      flex-direction: column;

      .new-card-search {
        padding: 20px 20px;
        display: flex;
        position: relative;
        border-bottom: 1px solid rgb(230, 230, 230);
        height: 188px;
        background-color: #fff;
        display: flex;
        justify-items: center;
        margin-bottom: 5px;

        .new-card-right {
          width: 100%;

          .card-right-top {
            display: flex;
            font-size: 15px;
            color: #409eff;
            justify-content: space-between;
            align-items: center;
            margin-left: 10px;
            margin-top: 10px;
            padding-bottom: 20px;
            border-bottom: 1px solid #e9ecf1;

            .card-right-top-right {
              span {
                font-size: 14px;
                background-color: #409EFF;
                padding: 4px 6px;
                margin-left: 10px;
                color: #FFF;
                border-radius: 4px;
              }
            }
          }

          .card-right-bottom {
            display: flex;
            justify-items: center;
            margin-bottom: 20px;

            .card-right-bottom-edu {
              margin-left: 10px;
              width: 466px;

              .edu-text {
                margin-top: 18px;
                font-size: 14px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .card-right-bottom-work {
              margin-left: 10px;
              width: 466px;

              .work-text {
                margin-top: 18px;
                font-size: 14px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }

      .read {
        color: #999;
        position: relative;

        .new-card-right {

          .card-right-top {
            color: #999;

            .card-right-top-right {
              span {
                background-color: #999;
              }
            }
          }
        }

        .isRead {
          border-right: 40px solid transparent;
          border-top: 46px solid #f5f5f5;
          height: 0;
          left: 0;
          position: absolute;
          top: 0;
          width: 0;

          div {
            color: #999;
            font-size: 14px;
            font-weight: 500;
            left: 6px;
            position: absolute;
            top: -39px;
            -webkit-transform: rotate(-54deg);
            transform: rotate(-54deg);
          }
        }
      }

      .share {
        position: relative;

        .isShare {
          border-left: 40px solid transparent;
          border-top: 46px solid #f5f5f5;
          height: 0;
          right: 0;
          position: absolute;
          top: 0;
          width: 0;

          div {
            color: #409eff;
            font-size: 14px;
            font-weight: 500;
            left: -19px;
            position: absolute;
            top: -43px;
            -webkit-transform: rotate(-40deg);
            transform: rotate(-40deg);
          }
        }
      }
    }

    .new-card-search:hover {
      background-color: rgb(248, 248, 248);

    }
  }

  .pag {
    width: 1000px;
    margin-top: 10px;
    padding: 5px 15px;
    background: #fff;
    border-radius: 5px;
    display: flex;
    justify-content: right;
  }
}
</style>